import type { RfaFormControl } from '../../level1/models';
import type { RfaComponents } from '../components/RfaComponents';
import type { RfaComponentOptions } from '../models';

export function getAriaDescribedBy(
  control: RfaFormControl<any, typeof RfaComponents._Any>
): string {
  const options = control.options as RfaComponentOptions & {
    helpText?: string;
  };

  let describedBy = `${control.id}-label`;
  if (control.hasError()) {
    describedBy += ` ${control.id}-validation`;
  }
  if (options.helpText) {
    describedBy += ` ${control.id}-help`;
  }

  return describedBy;
}
